import React, { Component } from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'

import { Get } from 'utils/axios-template'

const Pages = ( WrappedComponent ) => {
  class PagesHOC extends Component {
    state = {
      loading: false,
      selectedPage: {},
      pages: []
    }

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })
    requestError = error => toast.error( error, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })

    onChangePagesHOC = ( key, val ) => this.setState({ [ key ]: val })

    getPages = ( site_id ) => Get(
      `/api/v1/sites/${ site_id }/pages`,
      this.getPagesSuccess,
      this.getPagesError,
      this.load
    )
    getPagesSuccess = payload => this.setState({ pages: payload.data })
    getPagesError = error => this.requestError( error )

    getSelectedPage = ( site_id, page_id ) => Get(
      `/api/v1/sites/${ site_id }/pages/${ page_id }`,
      this.getSelectedPageSuccess,
      this.getSelectedPageError,
      this.load
    )
    getSelectedPageSuccess = payload => this.setState({ selectedPage: payload })
    getSelectedPageError = error => this.requestError( error )

    render = () => {
      return (
        <>
          <WrappedComponent
            { ...this.props }
            getSelectedPage={ this.getSelectedPage }
            onChangePagesHOC={ this.onChangePagesHOC }
            getPages={ this.getPages }
            selectedPage={ this.state.selectedPage }
            onLoadPages={ this.state.loading }
            pages={ this.state.pages } />
        </>
      )
    }
  }
  return PagesHOC
}

export default Pages